import { useId, useLayoutEffect, useRef, useState } from "react";

// Long text cut to a few lines, with "Read more" once it runs longer.
// className styles the text and, with "--clamped" added, cuts it: the
// stylesheet says after how many lines. buttonClassName styles the button.
function ClampedText({
	text,
	className,
	buttonClassName,
}: Readonly<{ text: string; className: string; buttonClassName: string }>) {
	const textRef = useRef<HTMLParagraphElement>(null);
	const textId = useId();
	const [expanded, setExpanded] = useState(false);
	const [overflows, setOverflows] = useState(false);

	// Measured while clamped, and again whenever the paragraph resizes, such
	// as when the window is narrowed.
	useLayoutEffect(() => {
		const element = textRef.current;
		if (!element || expanded) return;
		const measure = () =>
			setOverflows(element.scrollHeight > element.clientHeight + 1);
		measure();
		const observer = new ResizeObserver(measure);
		observer.observe(element);
		return () => observer.disconnect();
	}, [text, expanded]);

	return (
		<>
			<p
				id={textId}
				ref={textRef}
				className={expanded ? className : `${className} ${className}--clamped`}
			>
				{text}
			</p>
			{(overflows || expanded) && (
				<button
					type="button"
					className={buttonClassName}
					aria-expanded={expanded}
					aria-controls={textId}
					onClick={() => setExpanded((value) => !value)}
				>
					{expanded ? "Show less" : "Read more"}
				</button>
			)}
		</>
	);
}

export default ClampedText;
